<ng-container *ngIf="dataSet === undefined || showLoader">
  <app-preloader [loaderText]="'Loading data...'" class="w-100 h-100 position-fixed preloader-backdrop"></app-preloader>
</ng-container>
<div class="mt-3 d-flex justify-content-end" *ngIf="showResetFilter">
  <button class="btn btn-clear border btn-sm"  [disabled]="!enableResetBtn"  (click)="resetFilter()">Reset Filter</button>
</div>

<div class="col-12" *ngIf="checkedRows.length && dataSet">
  <div class="px-3 py-2 mb-2 bg-light border d-flex justify-content-start align-items-center">
    <p class="mb-0">
      {{checkedRows.length}}
      {{checkedRows.length>1 ? 'items' : 'item'}} on total list
      {{checkedRows.length>1 ? 'are' : 'is'}} selected.</p>
    <button
      type="button"
      class="btn btn-clear py-0 px-2 ml-2 text-underline"
      id="clrselectionBtn"
      (click)="clearAllSelection()">Clear selection
    </button>
  </div>
</div>

<div class="col-12 mt-3 px-0" [ngClass]="{'p-0': viewLocation==='configFilters'}">
  <table id="dataTable" class="table table-hover" [class.home-table]="tableCategory === 'home'" role="grid"
    aria-readonly="true">
    <caption class="sr-only">{{tableCategory}} listing</caption>
    <thead>
      <tr role="row">
        <th role="columnheader" scope="col" *ngIf="showCheckBox && uniqueField && dataSet && dataSet.length>0"
          class="col-30">
          <span class="sr-only">taxonomy group option</span>
          <div class="d-flex justify-content-between col-auto px-0" [ngClass]="{'pl-4': !showAllCheckBox}"
            *ngIf="showAllCheckBox">
            <span class="custom-control custom-checkbox m-0">
              <input type="checkbox" id="selectall" class="custom-control-input" [checked]="checkedPages[pageIndex]"
                (click)="onRowChecked('paginatedAll', $event)" [disabled]="disabledAllCheckbox">
              <label for="selectall" id="selectallLabel" class="custom-control-label d-flex">
                <span class="sr-only">select all taxonomies</span>
              </label>
            </span>
          </div>
        </th>

        <th role="columnheader" scope="col" *ngFor="let column of columnList; let $index = index"
          [ngClass]="column.class" [class.sr-only]="!showHeader" [class.active]="column.isSorted"
          [attr.aria-sort]="column.isSorted ? (column.isAsc?'ascending':'descending'): null"
          [style.width]="setWidth(column)" [style.flex-basis]="setWidth(column)" [style.max-width]="setWidth(column)">
          <div class="w-100 d-flex justify-content-start">
            <button class="btn-icon btn-table-title sort font-bold font-1x p-0 d-flex text-left align-items-start"
              id="{{'sort-'+$index}}" (click)="sortData(column)" *ngIf="sortRequired && !column.hideSort"
              [class.active]="column.isSorted"
              [attr.aria-label]="(column.isSorted ? 'sorted by ' : '')+ column.name + (column.isSorted ? (column.isAsc ? ' ascending' : '  descending') : '')">
              <span id="columnTitle{{column.name}}" class="font-2x d-flex w-100">{{column.name}}</span>
              <em class="material-icons-outlined d-flex ml-2 custom-icon-sorting"
                attr.aria-label="{{ 'column ' + column.name}}"
                [ngStyle]="{'transform': column.isAsc ? 'rotate(180deg)' : 'rotate(0deg)'}">
                <span aria-hidden="true">arrow_upward</span>
              </em>
            </button>
            <p *ngIf="!sortRequired" id="columnTitle{{column.name}}" class="font-bold font-2x d-flex w-100">
              {{column.name}}</p>

            <ng-container *ngIf="column.canFilter && column.showFilter && filterList[column.propName]">
              <app-multi-select-dropdown #multiSelect [label]="column.name" [data]="filterList[column.propName]"
                [lastIndex]="(columnList.length === $index+1) || (columnList.length-2 === $index)?true:false"
                id="{{'multiselect-'+$index}}" [dropdownSettings]="dropdownSettings" [viewLocation]="'datatable'"
                [selectedOptionList]="selectedOptionList" (SelectEvent)="onFilterOptionSelect($event, column,$index)">
              </app-multi-select-dropdown>
            </ng-container>

          </div>
          <span *ngIf="column.type === 'button'" class="sr-only">{{column.value}} option</span>
        </th>

        <th role="columnheader" 
            scope="col" 
            *ngIf="showMenu && tableCategory === 'modal-table' " 
            id="optionColumn" 
            style="width: 22%">
          <span class="sr-only">Delete</span>
        </th>

        <th role="columnheader" scope="col" *ngIf="showMenu && moreOptionAvailable " id="optionColumn" style="width: 3%">
          <span class="sr-only">More option</span>
        </th>

        <th role="columnheader" scope="col" *ngIf="displayBtn" id="displaySetting" class="sr-only">
          Configure settings
        </th>
      </tr>
    </thead>

    <tbody class="tbody">
      <ng-container *ngIf="!showLoader">
        <tr role="row" class="tr"
          *ngIf="(dataSet && dataSet.length === 0) || (isSearchNeeded && filterData && filterData.length === 0)">
          <td role="gridcell" class="text-center" [attr.colspan]="columnList?.length+1">
            <p class="mb-0" role="alert"><span class="sr-only">Error</span> No Data Found</p>
          </td>
        </tr>

        <ng-container
          *ngFor="let data of dataSet | customFilter: getColumnFilterObj() | slice:startIndex:lastIndex; let l = count; let rowIndex = index; ">

          <tr id="{{'rowId_'+rowIndex}}" role="row" [ngClass]="{'pl-2': viewLocation==='report', 'active': (viewLocation==='report' && data?.id===selectedData?.id),
            'checked':(data.checked)}">

            <ng-container *ngFor="let column of columnList; let i = index">
              <td role="gridcell" *ngIf="showCheckBox && uniqueField && i === 0" class="col-30">
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    id="{{'check_'+rowIndex}}"
                    class="custom-control-input"
                    [checked]="data.checked"
                    (click)="onRowChecked('single', $event, data)">
                  <label
                    for="{{'check_'+rowIndex}}"
                    class="custom-control-label d-flex"
                    id="{{'checkLabel_'+rowIndex}">
                      <span class="sr-only">select {{data[column.propName]}}</span>
                  </label>
                </div>
              </td>

              <td [ngClass]=" column.class" *ngIf="column.type === 'text'" role="gridcell">
                <p
                  id="{{column.name + '_' + rowIndex}}"
                  class="mb-0 text-wrapped">
                    {{column.propName == 'state' ? data[column.propName] == 1 ? 'Archived' : 'Active' : data[column.propName]}}
                </p>
              </td>

              <td *ngIf="displayBtn">
                <div class="col-auto d-flex justify-content-end pr-1">
                  <button type="button"
                          id="{{'dispalySettingsBtn_' + rowIndex}}"
                          class="btn btn-secondary btn-sm btn-display d-flex align-items-center font-bold font-2x display-settings"
                          attr.aria-label="Display Settings"
                          attr.aria-labelledby="{{column.name + '_' + rowIndex}} {{'dispalySettingsBtn_' + rowIndex}}"
                          (click)="onProjectSelected(data)">
                          <span class="material-icons-outlined pr-2 font-4x"
                                aria-hidden="true">picture_in_picture</span>
                                Display Settings
                  </button>
                </div>
              </td>

              <td [ngClass]=" column.class" *ngIf="column.type === 'button'" role="gridcell">
                <!-- this will appear for single download item -->
                <ng-container *ngIf="!multiDwnld">
                  <button 
                    id="{{column.name + '_' + rowIndex}}"
                    class="btn btn-icon tooltip top position-relative btn-common" 
                    (click)="setDownloadEvent(data)"
                    data-tooltip="Download">
                      <em 
                        class="material-icons-outlined font-4x button-icon" 
                        aria-hidden="true">file_download
                        <span 
                          class="sr-only sr-only-focusable">
                          export {{data[columnList[0].propName]}}
                        </span>
                      </em>
                  </button>
                </ng-container>
                <!-- end of single dropdown item -->

                <!-- this will appear for more dropdown items -->
                <ng-container *ngIf="multiDwnld">
                  <div class="more-option dropdown pr-2">
                    <button type="button" 
                            id="downloadMoreOption_{{rowIndex}}"
                            class="btn btn-clear btn-elipses p-0 dropdown-toggle" 
                            data-toggle="dropdown" 
                            data-display="static"
                            aria-haspopup="true" 
                            aria-expanded="false" 
                            data-reference="parent"
                            attr.aria-controls="downloadMoreOptionItems_{{rowIndex}}" 
                            (focus)="onFocus(data,rowIndex)"
                            (click)="setFocus(rowIndex);"
                            [attr.aria-label]="'download PDF/CSV for ' + data[columnList[0].propName]">
                              <span 
                                class="material-icons-outlined font-4x button-icon" 
                                aria-hidden="true">file_download
                              </span>
                    </button>

                    <div  class="dropdown-menu dropdown-menu-left"
                          attr.aria-labelledby="downloadMoreOption_{{rowIndex}}">
                      <div id="downloadMoreOptionItems_{{rowIndex}}" role="menu">
                        <ng-container *ngFor="let option of optionList;let ind = index">
                          <button type="button" 
                                 *ngIf="option.id !== 'pdf'" 
                                  class="btn btn-clear dropdown-item" 
                                  id="DrpCsv_{{rowIndex}}" 
                                  (click)="setDownloadEvent(data,option.id)">{{option.name}}
                                  <span class="sr-only">Opens in a new dialog</span>
                          </button>

                          <ng-container *ngIf="!option?.url">
                            <button tabindex="-1" 
                                    type="button" 
                                    id="{{option.name.split(' ').join('')+'_'+rowIndex}}"
                                    class="btn btn-clear dropdown-item" 
                                    [attr.data-toggle]="option.modal? 'modal' : null"
                                    [hidden]="!data[option.check]" 
                                    [attr.data-target]="option.modal? option.modal : null"
                                    (click)="onOptionClicked($event, option.type, data, ind,option.name)" 
                                    role="menuitem"> {{option.name}} 
                                    <span class="sr-only">Opens in a new dialog</span>
                            </button>
                          </ng-container>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <!-- end of dropdown with items -->
              </td>

              <td role="gridcell" [ngClass]="column.class" *ngIf="column.type === 'date'"
                [style.flex-basis]="isConfigurable && setWidth(column)">

                <p
                  *ngIf="column.dateType === 'amCalendar'"
                  class="mb-0 text-wrapped"
                  id="{{column.name + '_' + i}}">
                    {{ (data[column.propName] && data[column.propName].length > 0)
                      ? (changeDateToLocalTimeZone(data[column.propName])| amCalendar
                    :{sameDay:'[Today at] h:mm A'}) : ('') }}
                </p>
                <p
                  *ngIf="column.dateType === 'amTimeAgo'"
                  class="mb-0 text-wrapped"
                  id="{{column.name + '_' + i}}">
                    {{ changeDateToLocalTimeZone(data[column.propName])| amTimeAgo
                      : column.propName === 'created_at'
                      ? true : false }}
                </p>
              </td>

              <td role="gridcell" [ngClass]="column.class" *ngIf="column.type === 'dropdown'"
                [style.flex-basis]="isConfigurable && setWidth(column)">

              <p *ngIf= "!roleStatusButton"
                id="{{column.name + '_' + rowIndex}}"
                class="mb-0 text-wrapped">
                  {{data[column.propName]}}
              </p>

                <div class="dropdown" *ngIf= "roleStatusButton">
                  <button type="button"  class="btn btn-clear p-0 text-underline"
                    id="{{'dropdownStatus_'+  rowIndex + '_' + data[column.propName]}}" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false" data-reference="parent"
                    (focus)="onFocus(data,rowIndex)">{{data[column.propName]}}</button>

                  <div class="dropdown-menu dropdown-menu-left"
                    [attr.aria-labelledby]="'dropdownStatus_'+ rowIndex + '_' + data[column.propName]">
                    <button type="button" class="btn btn-clear dropdown-item"
                      id="{{item.name.split(' ').join('')+'_'+i}}"
                      (click)="changeStatus(item.value,data[item.propName])"
                      *ngFor="let item of dropdownItems; let i = index">{{item.name}}</button>
                  </div>
                </div>
              </td>

              <th scope="row" role="rowheader" [ngClass]="column.class" *ngIf="column.type === 'link'"
                [style.flex-basis]="isConfigurable && setWidth(column)">
                <a *ngIf="column.redirect && !column.loadPage && !column.isTaxonomyProject" href="{{data[column.propName]}}" target="_blank"
                  class="text-underline" (focus)="onFocus(data, rowIndex)" rel="noopener">{{column.value}}</a>
                <button *ngIf="column.redirect && column.loadPage && !column.isTaxonomyProject"
                  class="btn btn-clear text-wrapped text-left p-0 pr-2 text-underline table-title"
                  id="{{column.name + '_' + i}}" (click)="onProjectSelected(data)" (focus)="onFocus(data, rowIndex)"
                  [innerHtml]="data[column.propName]"></button>
                <button *ngIf="!column.redirect && !column.isTaxonomyProject" class="btn btn-clear p-0 user-status" data-toggle="modal"
                  [attr.data-target]="column.modal" (focus)="onFocus(data, rowIndex)"
                  (click)="getCurrentRequestDetails(data)" [innerHtml]="data[column.propName]"></button>
                <button *ngIf="column.isTaxonomyProject"
                  role="link"
                  class="btn text-wrapped text-left p-0 pr-2 table-title d-flex align-items-center"
                  id="{{column.name + '_' + i}}" (click)="onTaxonomyProjectSelected(data)">
                    <span class="btn-clear text-underline" [innerHtml]="data[column.propName]"></span>
                    <span class="sr-only">&nbsp; Opens in a new window</span>
                    <span class="open-new-window material-icons-outlined font-3x ml-1" aria-hidden="true">
                      open_in_new
                    </span>
                  </button>
                  
              </th>

              <td role="gridcell" [ngClass]="column.class" *ngIf="column.type === 'array'"
                [style.flex-basis]="isConfigurable && setWidth(column)">

                <div class="nested-cell" *ngFor="let item of data[column.propName];">
                  <p class="mb-0 text-wrapped">
                    <!-- Here 'column.attributes' is array object's property which needs to print in table -->
                    <ng-container *ngFor="let attr of column.attributes; let i = index;">
                      <span [attr.class]="attr?.class"
                        [mathJax]="item[attr.name+'_html'] ? item[attr.name+'_html'] : item[attr.name]"></span>
                    </ng-container>
                  </p>
                </div>
              </td>
            </ng-container>

            <td role="gridcell" *ngIf="showMenu && moreOptionAvailable" class="col-auto text-right">
              <div class="more-option dropdown pr-2" [hidden]="!data.showOptions || data.is_locked">
                <button type="button" id="moreOption_{{rowIndex}}" class="btn btn-clear btn-elipses p-0 dropdown-toggle"
                  data-toggle="dropdown" data-display="static" aria-haspopup="true" aria-expanded="false"
                  data-reference="parent" attr.aria-controls="moreOptionItems_{{rowIndex}}"
                  (focus)="onFocus(data,rowIndex)" (click)="setFocus(rowIndex);"
                  [attr.aria-label]="'more options for' + data[columnList[0].propName]">
                  <span class="material-icons-outlined font-4x" aria-hidden="true">more_horiz</span>
                </button>

                <div class="dropdown-menu dropdown-menu-right" attr.aria-labelledby="moreOption_{{rowIndex}}">
                  <div id="moreOptionItems_{{rowIndex}}" role="menu">
                    <ng-container *ngFor="let option of optionList;let ind = index">
                      <a *ngIf="option.url" href="{{data[option.propName]}}" class="dropdown-item"
                        [hidden]="!data[option.check]" target="_self" aria-label="download document"
                        role="menuitem">{{option.name}}</a>

                      <ng-container *ngIf="!option?.url && tableCategory !== 'taxonomy' && option.check !== 'isComment'">
                        <button tabindex="-1" type="button" id="{{option.name.split(' ').join('')+'_'+rowIndex}}"
                          class="btn btn-clear dropdown-item" [attr.data-toggle]="option.modal? 'modal' : null"
                          [hidden]="!data[option.check]" [attr.data-target]="option.modal? option.modal : null"
                          (click)="onOptionClicked($event, option.type, data, ind,option.name)" role="menuitem">
                          {{option.name}}<span class="sr-only">Opens in a new dialog</span>
                        </button>
                      </ng-container>
                      <ng-container *ngIf="!option?.url && tableCategory !== 'taxonomy' && option.check === 'isComment'">
                        <button tabindex="-1" type="button" id="{{option.name.split(' ').join('')+'_'+rowIndex}}"
                          class="btn btn-clear dropdown-item" [attr.data-toggle]="option.modal? 'modal' : null"
                          [attr.data-target]="option.modal? option.modal : null"
                          (click)="onOptionClicked($event, option.type, data, ind,option.name)" role="menuitem">
                          {{option.name}} {{data.isComment ? "OFF" : "ON"}}<span class="sr-only">Opens in a new dialog</span>
                        </button>
                      </ng-container>
                      <ng-container *ngIf="!option?.url && tableCategory === 'taxonomy' && option.modal === '#project-link'">
                        <button tabindex="-1" type="button" id="{{option.name.split(' ').join('')+'_'+rowIndex}}"
                          class="btn btn-clear dropdown-item" [attr.data-toggle]="option.modal && data.status !== 5 && data.project_details.length > 0 ? 'modal' : null"
                          [hidden]="!data[option.check]" [attr.data-target]="option.modal && data.status !== 5 && data.project_details.length > 0 ? option.modal : null"
                          (click)="onOptionClicked($event, option.type, data, ind,option.name)" role="menuitem">
                          {{option.name}}<span class="sr-only">Opens in a new dialog</span>
                        </button>
                      </ng-container>
                      <ng-container *ngIf="!option?.url && tableCategory === 'taxonomy' && option.modal !== '#project-link'">
                        <button tabindex="-1" type="button" id="{{option.name.split(' ').join('')+'_'+rowIndex}}"
                          class="btn btn-clear dropdown-item" [attr.data-toggle]="option.modal? 'modal' : null"
                          [hidden]="!data[option.check]" [attr.data-target]="option.modal? option.modal : null"
                          (click)="onOptionClicked($event, option.type, data, ind,option.name)" role="menuitem">
                          {{option.name}}<span class="sr-only">Opens in a new dialog</span>
                        </button>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </div>
            </td>
            <td role="gridcell" 
              *ngIf="showMenu && tableCategory === 'modal-table'"
              class="col-auto text-right">
                <button class="btn btn-link p-0" type="button"
                  (click)="onProjectDelete(data)"
                  *ngIf="deleteInprogress !== data.project_id">Delete Project
                    <span class="sr-only">&nbsp; {{data.project_name}}</span>
                </button>
                <p class="mb-0 text-danger" role="status" aria-live="polite"
                *ngIf="deleteInprogress === data.project_id">Deleting
                  <span class="sr-only">&nbsp; {{data.project_name}}</span>...
                </p>
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </tbody>
  </table>
  <span id="liveRegion" aria-live="polite" readCaptions="false"></span>
</div>

<ng-container *ngIf="tableCategory !== 'home'">
  <app-pagination #paginationRef
    *ngIf="dataSet !== undefined && (filterData && filterData.length > minItemPerPage) && !showLoader"
    [dataLength]="filterData ? filterData.length : 0" [defaultPageRange]="pagination"
    (displayItemRangeEvent)="showDataInRange($event)">
  </app-pagination>
</ng-container>